import React, { Component } from 'react';
import styled from 'styled-components';
import { PrestoAppTheme } from 'presto-mini-apps-lib';
import { phrase_DefaultError } from '../../constants/text';
import DigitItem from './DigitItem';
import ErrorMessage from '../ErrorMessage';

class DigitInputWithLabel extends Component {

    constructor(props) {
        super(props);
        this.values = Array(props.length)
            .fill('')
            .map((x, i) => props.initialValue.toString()[i] || '');
        this.elements = [];
        this.currentIndex = 0;
    }

    componentDidUpdate(prevProps) {
        const { 
            clearField
        } = this.props;

        if(prevProps.clearField !== clearField) {
            if(clearField) {
                this.clear();
            }
        }
    }

    onItemChange = (value, isPasting, index) => {
        const { length, onComplete, onChange } = this.props;
        let currentIndex = index;

        this.values[index] = value;

        // Set focus on next
        if (value.length === 1 && index < length - 1) {
            currentIndex += 1;
            this.elements[currentIndex].focus();
        }

        // Notify the parent
        const pin = this.values.join('');

        if (!isPasting) {
            onChange(pin, currentIndex);
        }

        if (pin.length === length) {
            // for pasting, trigger onChange only when the last input triggers onChange
            if (isPasting && index < length - 1) {
                return;
            }

            onChange(pin, currentIndex);
        }
    }

    onBackspace = (index) => {
        if (index > 0) {
            this.elements[index - 1].focus();
        }
    }

    onPaste = (value) => {
        const { length } = this.props;
        if (value.length !== length) {
            return;
        }

        this.elements.forEach((el, index) => el.update(value[index], true));
    }

    onKeyDown = (e, index) => {
        const { length, enterTrigger } = this.props;
        if (enterTrigger && index === length - 1) {
            enterTrigger(e);
        }
    }

    focus = () => {
        this.elements[0].focus();
    }

    clear = () => {
        this.elements.forEach((el, index) => el.update('', false));
    }

    render() {
        const {
            label,
            type = 'text',
            value,
            isError,
            errorMessage = phrase_DefaultError,
            disabled,
        } = this.props;

        return (
            <DigitInputWrapper className="digit-input-component">
                {(!!label && label !== '') &&
                    <div className="label">{label}</div>
                }
                <div className="digit-container">
                    {this.values.map((value, i) => (
                        <DigitItem
                            initialValue={value}
                            ref={n => (this.elements[i] = n)}
                            key={i}
                            type={type}
                            onBackspace={() => this.onBackspace(i)}
                            onChange={(v, isPasting) => this.onItemChange(v, isPasting, i)}
                            onPaste={i === 0 ? this.onPaste : null}
                            onKeyDown={(e) => this.onKeyDown(e, i)}
                            disabled={disabled}
                        />
                    ))}

                </div>
                {!!isError && <ErrorMessage message={errorMessage} />}
            </DigitInputWrapper>
        )
    }
}

export default DigitInputWithLabel;

const DigitInputWrapper = styled.div`
    margin-bottom: ${PrestoAppTheme.layout.smallGap};

    & > .label { 
        font-size: ${PrestoAppTheme.layout.fontSizeXSmall};
        font-weight: 400;
        text-transform: uppercase;
    }

    & > .digit-container {
        display: flex;
        justify-content: space-between;
        margin-top: ${PrestoAppTheme.layout.smallGap};
        width: 100%;

        & input { 
            height: 2.1rem;
            line-height: 2.1rem;
            font-weight: 300;

            &:focus, 
            &:active {
                outline: 0;
            }
                
            &[type=password]::-ms-reveal { 
                display: none; 
            }

            &.box {
                border: 1px solid ${PrestoAppTheme.colors.baseGrey};
                text-align: center;
                width: 2.1rem;
                height: 2.1rem;
                border-radius: 0.2rem;

                @media (min-width: 768px) {
                    width: 2.5rem;
                    height: 2.5rem;
                }

                @media only screen and (max-width: 320px) {
                    width: 1.9rem;
                    height: 1.9rem;
                }
            }
        }
    
    }

`